// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextBubble__content-a2f632 {
  background-color: inherit;
}

.TextBubble__content-text-f3a80f {
  display: inline;
}

.TextBubble__bubble-d4cd54 {
  padding: 10px 12px 0;
}

.TextBubble__bubble-d4cd54:after {
  content: "";
  display: table;
  clear: both;
}

.TextBubble__sender-name-e38adf {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.TextBubble__sender-name-e38adf.TextBubble__wide-gap-c82e4a {
  margin-bottom: 4px;
}

.TextBubble__quote-e2a810 {
  margin-bottom: 9px;
}

.TextBubble__forward-d93773 {
  margin-bottom: 4px;
}

.TextBubble__status-bar-ca5746 {
  float: right;
  margin: 4px 0 10px 8px;
}

.TextBubble__thread-button-e411e4 {
  margin: 0 -12px;
}

.TextBubble__translate-c2efd1 {
  margin: 0 -12px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/TextBubble/TextBubble.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,sBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF","sourcesContent":[".content {\n  background-color: inherit;\n}\n\n.content-text {\n  display: inline;\n}\n\n.bubble {\n  padding: 10px 12px 0;\n}\n\n.bubble:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &.wide-gap {\n    margin-bottom: 4px;\n  }\n}\n\n.quote {\n  margin-bottom: 9px;\n}\n\n.forward {\n  margin-bottom: 4px;\n}\n\n.status-bar {\n  float: right;\n  margin: 4px 0 10px 8px;\n}\n\n.thread-button {\n  margin: 0 -12px;\n}\n\n.translate {\n  margin: 0 -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TextBubble__content-a2f632`,
	"content-text": `TextBubble__content-text-f3a80f`,
	"contentText": `TextBubble__content-text-f3a80f`,
	"bubble": `TextBubble__bubble-d4cd54`,
	"sender-name": `TextBubble__sender-name-e38adf`,
	"senderName": `TextBubble__sender-name-e38adf`,
	"wide-gap": `TextBubble__wide-gap-c82e4a`,
	"wideGap": `TextBubble__wide-gap-c82e4a`,
	"quote": `TextBubble__quote-e2a810`,
	"forward": `TextBubble__forward-d93773`,
	"status-bar": `TextBubble__status-bar-ca5746`,
	"statusBar": `TextBubble__status-bar-ca5746`,
	"thread-button": `TextBubble__thread-button-e411e4`,
	"threadButton": `TextBubble__thread-button-e411e4`,
	"translate": `TextBubble__translate-c2efd1`
};
module.exports = ___CSS_LOADER_EXPORT___;
